import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import './i18n/config';

const initApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Check if Office.js is available
if (typeof Office !== 'undefined') {
  Office.onReady(() => {
    initApp();
  });
} else {
  // Running in browser without Office.js
  initApp();
}
